<template>
  <div id="app">
    <Reseller msg="test1"/>
  </div>
</template>

<script>
import Reseller from './components/Reseller.vue'

export default {
  name: 'app',
  components: {
    Reseller
  }
}
</script>

<style src="./assets/styles/index.less" lang="less"></style>
